module.exports = __webpack_public_path__ + "static/media/sin_favoritos.cb2f68a2.svg";